<!--
 * @Description: 混凝土结算审批
 * @Author: wangwangwang
 * @Date: 2020-11-18 15:34:16
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-12-21 16:54:22
-->
<template>
    <div class="flows-content">
        <el-container>
            <el-main style="margin-bottom: 20px; padding: 0;">
                <el-container direction="vertical">
                    <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)"
                        @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)"
                        @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)"
                        @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
                    <el-main class="info">
                        <div>
                            <el-input v-model="title" class="flow-title" :disabled="$route.query.type * 1 !== 1"
                                placeholder="请输入流程标题"></el-input>
                        </div>
                        <div class="info-top">
                            <div class="left">
                                <span>单据号码：{{ billCode }}</span>
                                <span class="text">制单日期：{{ billDate }}</span>
                            </div>
                            <div class="right">
                                <span>发起人：{{ applyPerson }}</span>
                                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
                            </div>
                        </div>
                        <div class="bill_top">
                            <span><span class="text">工程名称：</span>{{ billData.engineeringName }}</span>
                            <span style="margin-left:24px"><span class="text">结算时间段：</span>{{ billData.lastDueTime }}至{{
                                billData.endDueTime
                            }}</span>
                        </div>
                        <div class="bill_title1">
                            <span>结算信息</span>
                            <span v-if="dataType !== 3" style="margin-left:20px"><span class="text">工程名称：</span>
                                <el-select v-model="cycleId" style="width: 120px" placeholder="请选择">
                                    <el-option :key="1" label="汇总" :value="1"
                                        @click.native="changeEng(mainRow, false, true)"></el-option>
                                    <el-option :key="this.billData.cycleManageId" label="主工程"
                                        :value="this.billData.cycleManageId"
                                        @click.native="changeEng('', false)"></el-option>
                                    <el-option v-for="item in bindEngList" :key="item.childCycleId"
                                        :label="item.engineeringName" :value="item.childCycleId"
                                        @click.native="changeEng(item, true)"></el-option>
                                </el-select>
                            </span>
                            <el-button v-if="dataType !== 3" size="mini" class="bottom_all" style="margin-left: 24px"
                                @click="lookDialog1">查看调价</el-button>
                            <el-button v-if="dataType !== 3" size="mini" class="bottom_all" style="margin-left: 24px"
                                @click="priceMaintenanceDig = true">查看信息价</el-button>
                            <el-button size="mini" class="bottom_all" style="margin-left: 24px"
                                @click="LookcheckDetail">核对明细单</el-button>
                            <el-button v-if="dataType !== 3" size="mini" class="bottom_all" style="margin-left: 24px"
                                @click="exportSettle(2)">导出</el-button>
                            <el-button v-if="dataType !== 3" size="mini" class="bottom_all" style="margin-left: 24px"
                                @click="exportSettle(1)">导出(流转详情)</el-button>
                        </div>
                        <vxe-table ref="table1" border show-footer show-overflow height="400" align="center"
                            :data="newBillData.productSummarys" :row-config="{ isHover: true }"
                            :scroll-y="{ enabled: true }" :footer-method="footerMethod1">
                            <vxe-column field="startTime" title="价格时间段" width="250" :tooltip="true">
                                <template #default="{ row }">
                                    <span v-if="row.startTime">{{ row.startTime }}-{{ row.endTime }}</span>
                                    <span v-else>-</span>
                                </template>
                            </vxe-column>
                            <vxe-column field="settleItem" title="结算项" width="150">
                                <template #default="{ row }">
                                    <span v-if="row.settleItem == 1">图算结算单</span>
                                    <span v-if="row.settleItem == 2">票结结算单</span>
                                </template>
                            </vxe-column>
                            <vxe-column field="productName" title="产品名称">
                            </vxe-column>
                            <vxe-column field="amount" title="数量(m³)">
                            </vxe-column>
                            <vxe-column v-if="dataType !== 3" field="basicPrice" title="基本单价(元/m³)">
                            </vxe-column>
                            <vxe-colgroup v-if="dataType !== 3" :key="additional.join('-')" field="" title="附加收费项(元/m³)"
                                :min-width="80">
                                <template v-for="(item, index) in additional">
                                    <vxe-column :key="index" :field="item" :title="item" :min-width="80"></vxe-column>
                                </template>

                            </vxe-colgroup>
                            <vxe-column v-if="dataType !== 3" field="totalUnitPrice" title="结算单价(元/m³)">
                            </vxe-column>
                            <vxe-column v-if="dataType !== 3" field="totalMoney" title="结算额(元)">
                            </vxe-column>
                        </vxe-table>
                        <div v-if="dataType !== 3" class="bill_title1"></div>
                        <vxe-table v-if="dataType !== 3" key="table2" ref="table2" border show-footer show-overflow
                            align="center" :data="newBillData.differSummarys" :row-config="{ isHover: true }"
                            :scroll-y="{ enabled: true }" :footer-method="footerMethod2">
                            <vxe-column field="timeSlot" title="调价时间段" width="400">
                                <template #default="{ row }">
                                    <span>{{ row.startTime }}-{{ row.endTime }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column field="adjustType" title="调整类型">
                            </vxe-column>
                            <vxe-column field="productName" title="产品名称">
                            </vxe-column>
                            <vxe-column field="amount" title="数量(m³)">
                            </vxe-column>
                            <vxe-column field="differPrice" title="价差(元)">
                            </vxe-column>
                            <vxe-column field="alreadySettlePrice" title="已办结算价（元）">
                            </vxe-column>
                            <vxe-column field="newAdjustPrice" title="应办结算价（元）">
                            </vxe-column>
                            <vxe-column field="differMoney" title="结算额(元)">
                            </vxe-column>
                            <vxe-column field="remark" title="备注">
                            </vxe-column>
                        </vxe-table>
                        <div class="bill_title1">泵类别结算合计</div>
                        <vxe-table key="table3" ref="table3" border show-footer show-overflow align="center"
                            :data="newBillData.pumpSummarys" :row-config="{ isHover: true }" :scroll-y="{ enabled: true }"
                            :footer-method="footerMethod3">
                            <vxe-column field="product" title="产品名称">
                            </vxe-column>
                            <vxe-column field="amount" title="数量(m³)">
                            </vxe-column>
                            <vxe-column v-if="dataType !== 3" field="basicPrice" title="基本单价(元/m³)">
                            </vxe-column>
                            <vxe-column v-if="dataType !== 3" field="settlePrice" title="结算单价(元/m³)">
                            </vxe-column>
                            <vxe-column v-if="dataType !== 3" field="totalMoney" title="结算额(元)">
                            </vxe-column>
                        </vxe-table>
                        <div class="bill_title1">其他项结算合计</div>
                        <vxe-table key="table4" ref="table4" border show-footer show-overflow align="center"
                            :data="newBillData.smallVolumeSummarys" :row-config="{ isHover: true }"
                            :scroll-y="{ enabled: true }" :footer-method="footerMethod3">
                            <vxe-column field="product" title="产品名称">
                            </vxe-column>
                            <vxe-column field="amount" title="数量(m³)">
                            </vxe-column>
                            <vxe-column v-if="dataType !== 3" field="basicPrice" title="基本单价(元/m³)">
                            </vxe-column>
                            <vxe-column v-if="dataType !== 3" field="settlePrice" title="结算单价(元/m³)">
                            </vxe-column>
                            <vxe-column v-if="dataType !== 3" field="totalMoney" title="结算额(元)">
                            </vxe-column>
                        </vxe-table>
                        <div v-if="dataType == 2" class="bill_title1">调整明细</div>
                        <vxe-table v-if="dataType == 2" key="table7" ref="table7" border show-footer show-overflow
                            align="center" :data="newBillData.adjustDetailList" :row-config="{ isHover: true }"
                            :scroll-y="{ enabled: true }" :footer-method="footerMethod4">
                            <vxe-column field="timeSlot" title="调价时间段" width="400">
                                <template #default="{ row }">
                                    <span>{{ row.startTime }}-{{ row.endTime }}</span>
                                </template>
                            </vxe-column>
                            <vxe-column field="adjustType" title="调整类型">
                            </vxe-column>
                            <vxe-column field="product" title="产品名称">
                            </vxe-column>
                            <vxe-column field="adjustNum" title="数量(m³)">
                            </vxe-column>
                            <vxe-column field="adjustMoney" title="金额">
                            </vxe-column>
                            <vxe-column field="remark" title="备注">
                            </vxe-column>
                        </vxe-table>
                        <div v-if="dataType !== 3" class="bill_title">结算合计</div>
                        <vxe-table v-if="dataType !== 3" key="table6" ref="table6" border show-overflow align="center"
                            :data="newBillData.totalList" :row-config="{ isHover: true }" :scroll-y="{ enabled: true }">
                            <vxe-column field="planMaterialAmount" title="应收甲供材料(T)" width="150">
                            </vxe-column>
                            <vxe-column field="receiveMaterialAmount" title="已收甲供材料(T)">
                            </vxe-column>
                            <vxe-column field="measuresRatio" title="措施费比例">
                            </vxe-column>
                            <vxe-column field="whetherAdjustPrice" title="是否含调价">
                                <template #default="{ row }">
                                    <span v-if="row.whetherAdjustPrice == 0"> 否</span>
                                    <span v-if="row.whetherAdjustPrice == 1"> 是</span>
                                </template>
                            </vxe-column>
                        </vxe-table>
                        <vxe-table v-if="dataType !== 3" key="table5" ref="table5" border show-overflow align="center"
                            :data="newBillData.totalList" :row-config="{ isHover: true }" :scroll-y="{ enabled: true }">
                            <vxe-column field="settleAmount" title="本次结算量(m3)" width="150">
                            </vxe-column>
                            <vxe-column field="cumulativeSettleAmount" title="累计结算量(m3)" width="150">
                            </vxe-column>
                            <vxe-column field="measuresCost" title="采购措施费" width="150">
                            </vxe-column>
                            <vxe-column field="summaryMoney" title="汇总金额（元)" width="150">
                            </vxe-column>
                            <vxe-column field="cumulativeSettleMoney" title="累计结算金额（元)" width="150">
                            </vxe-column>
                            <vxe-column field="settleMoney" title="结算金额" width="150">
                            </vxe-column>
                            <vxe-column field="cumulativeMouthAmount" title="累计月报量" width="150">
                            </vxe-column>
                            <vxe-column field="cumulativeMouthMoney" title="累计月报产值" width="150">
                            </vxe-column>
                            <vxe-column field="planInvoiceMoney" title="已开发票额(元)" width="150">
                            </vxe-column>
                            <vxe-column field="settleInvoiceMoney" title="已收款额(元)" width="150">
                            </vxe-column>
                            <vxe-column field="loanArrearsMoney" title="已结算货款尚欠金额(元)" width="150">
                            </vxe-column>
                            <vxe-column field="planMaterialAmount" title="应收甲供材料(T)" width="150">
                            </vxe-column>
                            <vxe-column field="receiveMaterialAmount" title="已收甲供材料(T)" width="150">
                            </vxe-column>
                        </vxe-table>
                        <div class="bill_title1" style="padding-bottom: 15px">备注</div>
                        <el-row>
                            <el-col :span="24">
                                <el-input v-model="newBillData.totalList[0].remark" disabled type="textarea" :rows="3"
                                    placeholder="请输入内容">
                                </el-input>
                            </el-col>
                        </el-row>

                        <div class="bill_title1" style="padding-bottom: 15px"> 事项说明</div>
                        <el-row style="padding-bottom: 15px">
                            <el-col :span="24">
                                <el-input v-model="newBillData.totalList[0].eventExplain" type="textarea" disabled :rows="3"
                                    placeholder="请输入内容">
                                </el-input>
                            </el-col>
                        </el-row>
                        <div v-if="dataType == 1">
                            <span class="bill_title">印章类型</span>
                            <span style="margin-left: 24px;">
                                {{ newBillData.totalList[0].sealTypeName }}
                            </span>
                        </div>
                        <div class="bill_title">合同附件</div>
                        <div v-for="(item, index) in disClostDetail.fileFist" :key="index" style="color:#00b85c">
                            <el-link type="sucess" :underline="false" @click="lookFileDetail(item)">{{
                                item.fileName }}</el-link>
                            <a class="el-link" @click="lookFile(item)">
                                <i class="el-icon-download" style="padding:0 10px"></i>
                            </a>
                        </div>
                        <div v-if="dataType == 2">
                            <div class="bill_title">内审附件</div>
                            <div v-for="(item, index) in insideFiles" :key="index" style="color:#00b85c">
                                <el-link type="sucess" :underline="false" @click="lookFileDetail(item)">{{
                                    item.fileName }}</el-link>
                                <a class="el-link" @click="lookFile(item)">
                                    <i class="el-icon-download" style="padding:0 10px"></i>
                                </a>
                            </div>
                        </div>
                        <div class="bill_title">{{ dataType == 1 ? '内审附件' :
                            dataType == 2 ?
                                '返回附件' : '附件' }}</div>
                        <div v-for="(item, index) in files" :key="index" style="color:#00b85c">
                            <el-link type="sucess" :underline="false" @click="lookFileDetail(item)">{{
                                item.fileName }}</el-link>
                            <a class="el-link" @click="lookFile(item)">
                                <i class="el-icon-download" style="padding:0 10px"></i>
                            </a>
                        </div>
                        <div class="flows-details">
                            <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible"
                                @handleCancel="handleCancel" @sendCode="sendCode"
                                @sendProcessManagerId="sendProcessManagerId" @sendProcessVersionId="sendProcessVersionId"
                                @handleFinish="handleFinish" @handleBusiness="handleBusiness"
                                @resetFlowState="resetFlowState" @sendNodeList="getNodeList" />
                        </div>
                    </el-main>
                </el-container>
                <!-- 工程调价 -->
                <diaLog1 :dialog="dialog1" :isLook="true" :low="dialog1Low" @reset="reset"></diaLog1>
                <!-- 核对明细单弹窗 -->
                <checkDetail :visible.sync="checkDetailDig" :checkDetailType="checkDetailType" :centerRow="checkDetailRow"
                    :stationIdlist="stationIdlist" :isLook="true" :cycleId="cycleId"  :bindEngList="bindEngList" @resetCheckDetail="checkDetailDig = false" />
                <!-- 标号信息价 -->
                <priceMaintenance :visible.sync="priceMaintenanceDig" @reset="priceMaintenanceDig = false">
                </priceMaintenance>
                <!-- 导出 -->
                <settleExport :visible.sync="exportDig" :exportForm="exportForm" :isNode="isNode" />
            </el-main>
        </el-container>
    </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { getUserInfo } from "@/utils/auth.js";
import { updaetInternalSettleStatus, updaetConfirmSettleStatus, updateProcessSettleStatus, getStationByCompanyId, addExamineDataInternal, addExamineDataConfirm, addExamineDataProcess, queryChildEngCycles, queryRelevanceCycles, queryInternalSettleData, queryConfirmSettleData, getDisClostDetail,querySettleDataTotal,querySettleDataTotalConfirm } from "@/api/wise/settlementTask.js";
import priceMaintenance from "../priceMaintenance.vue";
import checkDetail from "../checkDetail.vue";
import settleExport from "../settleExport.vue";
import { getNodeList } from '@/api/task/flows';
const diaLog1 = () => import("@/views/platform/ICPS/internetSales/dialog/engineeringControl1");
export default {
    components: {
        FlowContent,
        FlowHeader,
        diaLog1,
        checkDetail,
        priceMaintenance,
        settleExport
    },
    data() {
        return {
            userInfo: "",
            type: 0,
            title: '结算任务审批',
            billCode: '',
            billDate: '',
            applyPerson: '',
            taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
            taskStatus: 0,
            readOnly: false,
            showSendVisible: false,
            billData: {
                productSummarys: [],
                differSummarys: [],
                pumpSummarys: [],
                additional: [],
                smallVolumeSummarys: [],
                totalList: [],
                deadlineDate: "",
            },
            additional: [],
            low: {},
            totalList1: [
            ],
            dataType: "",
            checkDetailType: 2,
            dialog1: false,
            priceMaintenanceDig: false,
            dialog1Low: {},
            checkDetailDig: false,
            stationIdlist: [],
            checkDetailRow: {},
            processManagerId: "",
            processVersionId: "",
            exportDig: false,
            exportForm: {},
            isNode: 1,
            cycleId: "",
            bindEngList: [],
            files: [],
            newBillData: {
                productSummarys: [],
                differSummarys: [],
                pumpSummarys: [],
                additional: [],
                smallVolumeSummarys: [],
                totalList: [
                    {
                        remark: "",
                        eventExplain: "",
                        sealTypeName: "",
                    }
                ],
                deadlineDate: "",
            },
            nodeList: [],
            disClostDetail: {},
        }
    },
    methods: {
        changeEng(item, isChild, isAll) {
            if (isAll) {
                let  ids = this.bindEngList.map(item =>{ return item.childCycleId })
                ids.push(this.billData.cycleManageId)
                this.exportForm.cycleManageId = ids.join("','")
                const querySettleDataTotalMethod = this.dataType == 1 ? querySettleDataTotal : querySettleDataTotalConfirm
                querySettleDataTotalMethod({ id: isChild ? item.childCycleId : this.billData.cycleManageId, childEngineeringList: this.bindEngList }).then(res => {
                    if (res.code == 1001 && res.data) {
                        let totalItem =
                        {
                            settleMoney: 0,
                            planMaterialAmount: 0,
                            receiveMaterialAmount: 0,
                            settleAmount: 0,
                            cumulativeSettleAmount: 0,
                            measuresCost: 0,
                            summaryMoney: 0,
                            cumulativeSettleMoney: 0,
                            measuresRatio: "",
                            measuresRatioId: "",
                            whetherAdjustPrice: 0,
                            planInvoiceMoney: 0,
                            settleInvoiceMoney: 0,
                            loanArrearsMoney: 0,
                            remark: "",
                            eventExplain: "",
                            enclosureUrl: null,
                            deductionAmount: 1012,
                            marginAmount: 0,
                            processManagerId: "",
                            processTaskId: "",
                            processVersionId: "",
                            sealTypeId: "",
                            sealTypeName: "",
                        }
                        let billData = {
                            productSummarys: res.data.productSummarys,
                            differSummarys: res.data.differSummarys,
                            pumpSummarys: res.data.pumpSummarys,
                            childCycles: this.bindEngList,
                            additional: [],
                            smallVolumeSummarys: res.data.smallVolumeSummarys,
                            adjustDetailList: res.data.adjustDetailList || [],
                            totalList: [res.data.auditTotal || totalItem],
                            cycleId: res.data.cycleId || this.low.id,
                            currentTime: res.data.currentTime
                        }
                        let enclosureUrl = res.data?.auditTotal?.enclosureUrl.split('?&')
                        let files = []
                        enclosureUrl.forEach(item => {
                            files = [...files, ...JSON.parse(item)]
                        })
                        if (
                            this.dataType == 2
                        ) {
                            queryInternalSettleData({ id: this.low.id }).then(res => {
                                let enclosureUrl2 = res.data?.auditTotal?.enclosureUrl.split('?&')
                                let files2 = []
                                enclosureUrl2.forEach(item => {
                                    files2 = [...files2, ...JSON.parse(item)]
                                })
                                this.insideFiles = files2
                                this.files = files
                            })
                        } else {
                            this.files = files
                        }
                        billData.differSummarys?.forEach(item => {
                            if (item.startTime && item.endTime) {
                                item['timeSlot'] = [item.startTime, item.endTime]
                            }

                        })
                        billData.adjustDetailList?.forEach(item => {
                            if (item.startTime && item.endTime) {
                                item['timeSlot'] = [item.startTime, item.endTime]
                            }

                        })
                        let additional = []
                        billData.productSummarys?.forEach(item => {
                            if (item.additionalMaterial) {
                                let additionalMaterial = JSON.parse(item.additionalMaterial)
                                let additionalChird = additionalMaterial.map(item2 => item2.name)
                                additional = [...new Set([...additional, ...additionalChird])];

                            }
                        })

                        billData.additional = additional
                        this.newBillData = billData
                        this.newBillData.productSummarys?.forEach(item => {
                            let additionalMaterialArr = item.additionalMaterial ? JSON.parse(item.additionalMaterial) : []
                            this.newBillData.additional.forEach(item2 => {
                                let obj = additionalMaterialArr.find(item3 => item3.name === item2)
                                item[item2] = obj ? Number(obj.price).toFixed(2) : '';
                            });
                        })
                        console.log(this.newBillData)
                        this.$forceUpdate()
                    }
                })
            } else {
                const queryMethod = this.dataType == 1 ? queryInternalSettleData : queryConfirmSettleData
                queryMethod({ id: isChild ? item.childCycleId : this.billData.cycleManageId }).then(res => {
                    if (res.code == 1001 && res.data) {
                        let totalItem =
                        {
                            settleMoney: 0,
                            planMaterialAmount: 0,
                            receiveMaterialAmount: 0,
                            settleAmount: 0,
                            cumulativeSettleAmount: 0,
                            measuresCost: 0,
                            summaryMoney: 0,
                            cumulativeSettleMoney: 0,
                            measuresRatio: "",
                            measuresRatioId: "",
                            whetherAdjustPrice: 0,
                            planInvoiceMoney: 0,
                            settleInvoiceMoney: 0,
                            loanArrearsMoney: 0,
                            remark: "",
                            eventExplain: "",
                            enclosureUrl: null,
                            deductionAmount: 1012,
                            marginAmount: 0,
                            processManagerId: "",
                            processTaskId: "",
                            processVersionId: "",
                            sealTypeId: "",
                            sealTypeName: "",
                        }
                        let billData = {
                            productSummarys: res.data.productSummarys,
                            differSummarys: res.data.differSummarys,
                            pumpSummarys: res.data.pumpSummarys,
                            childCycles: this.bindEngList,
                            additional: [],
                            smallVolumeSummarys: res.data.smallVolumeSummarys,
                            adjustDetailList: res.data.adjustDetailList || [],
                            totalList: [res.data.auditTotal || totalItem],
                            cycleId: res.data.cycleId || this.low.id,
                            currentTime: res.data.currentTime
                        }
                        let files = res.data?.auditTotal?.enclosureUrl ? JSON.parse(res.data.auditTotal.enclosureUrl) : []
                        if (
                            this.dataType == 2
                        ) {
                            queryInternalSettleData({ id: this.low.id }).then(res => {
                                let files2 = res.data?.auditTotal?.enclosureUrl ? JSON.parse(res.data.auditTotal.enclosureUrl) : []
                                this.insideFiles = files2
                                this.files = files
                            })
                        } else {
                            this.files = files
                        }
                        billData.differSummarys?.forEach(item => {
                            if (item.startTime && item.endTime) {
                                item['timeSlot'] = [item.startTime, item.endTime]
                            }

                        })
                        billData.adjustDetailList?.forEach(item => {
                            if (item.startTime && item.endTime) {
                                item['timeSlot'] = [item.startTime, item.endTime]
                            }

                        })
                        let additional = []
                        billData.productSummarys?.forEach(item => {
                            if (item.additionalMaterial) {
                                let additionalMaterial = JSON.parse(item.additionalMaterial)
                                let additionalChird = additionalMaterial.map(item2 => item2.name)
                                additional = [...new Set([...additional, ...additionalChird])];

                            }
                        })

                        billData.additional = additional
                        this.newBillData = billData
                        this.newBillData.productSummarys?.forEach(item => {
                            let additionalMaterialArr = item.additionalMaterial ? JSON.parse(item.additionalMaterial) : []
                            this.newBillData.additional.forEach(item2 => {
                                let obj = additionalMaterialArr.find(item3 => item3.name === item2)
                                item[item2] = obj ? Number(obj.price).toFixed(2) : '';
                            });
                        })
                        console.log(this.newBillData)
                        this.$forceUpdate()
                    }
                })
            }
        },
        reset(key) {
            this[key] = false;
        },
        LookcheckDetail() {
            this.checkDetailDig = true
        },
        lookDialog1() {
            this.dialog1Low = {
                id: this.billData.engineeringId
            }
            this.dialog1 = true
        },
        lookFileDetail(row) {
            if (row.path.endsWith('.jpg') || row.path.endsWith('.png') || row.path.endsWith('.jpeg')) {
                let imgUrl = 'https://lvshe.huashijc.com/file/' + row.path;
                window.open(imgUrl, "_blank");
            } else {
                this.$wps(row.path);
            }
        },
        lookFile(row) {
            let imgUrl = 'https://lvshe.huashijc.com/file/' + row.path;
            window.open(imgUrl, "_blank");
        },
        //合计
        sumNum1(list, field) {
            let count = 0
            const arr = ['洗泵水', '润泵水', '润泵砂浆'];
            list.forEach(item => {
                let result = arr.some(str => item['productName'].includes(str));
                if (!(field == 'amount' && result)) {
                    count += Number(item[field])
                }
            })
            return Number(count).toFixed(3)
        },
        sumNum(list, field) {
            let count = 0
            list.forEach(item => {
                count += Number(item[field])
            })
            // return field == 'amount' ? Number(count).toFixed(3) : Number(count).toFixed(2)
            return Number(count).toFixed(3)
        },
        footerMethod1({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '小计'
                    }
                    if (['amount', 'totalMoney'].includes(column.field)) {
                        return this.sumNum1(data, column.field)
                    }
                    return null
                }),
            ]
        },
        footerMethod2({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '小计'
                    }
                    if (['amount', 'differMoney'].includes(column.field)) {
                        return this.sumNum(data, column.field)
                    }
                    return null
                }),
            ]
        },
        footerMethod3({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '小计'
                    }
                    if (['amount', 'totalMoney'].includes(column.field)) {
                        return this.sumNum(data, column.field)
                    }
                    return null
                }),
            ]
        },
        footerMethod4({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '小计'
                    }
                    if (['adjustNum', 'adjustMoney'].includes(column.field)) {
                        return this.sumNum(data, column.field)
                    }
                    return null
                }),
            ]
        },
        //不同意回调  1为不同意 2为撤销
        resetFlowState(type) {
            if (type == 1) {
                this.handleBusiness()
            }
            if (type == 2) {
                const { query } = this.$route;
                const updateMethods = this.dataType == 1 ? updaetInternalSettleStatus : this.dataType == 2 ? updaetConfirmSettleStatus : updateProcessSettleStatus
                let params = {}
                if (this.dataType == 1) {
                    params = {
                        id: JSON.parse(query.dataContent).cycleManageId,
                        insideExamineSettlesStatus: 0,
                    }
                } else if (this.dataType == 3) {
                    params = {
                        id: JSON.parse(query.dataContent).cycleManageId,
                        settleStatus: 1,
                    }
                } else {
                    params = {
                        id: JSON.parse(query.dataContent).cycleManageId,
                        sureSelletesStatus: 0,
                    }
                }
                updateMethods(params).then(() => {
                })
            }

        },
        combined(arr, item) {
            let num = 0
            arr.forEach(res => {
                num = Number(res[item]) + num
            })
            return num.toFixed(2)
        },
        //handleData审批数据 handleData 参数
        handleBusiness(handleData) {
            const { query } = this.$route;
            let successData = {}
            let faileData = {}
            let remark = ''
            this.nodeList?.forEach(item => {
                item.instanceLogsList.forEach(item2 => {
                    //取李莎备注
                    if (item2.userId == '47406898051420160') {
                        remark = item2.approvalOptions
                    }
                })
            })
            if (this.userInfo.userId == '47406898051420160') {
                remark = handleData ? handleData.approvalOptions : remark
            }
            if (this.dataType == 1) {
                successData = {
                    id: JSON.parse(query.dataContent).cycleManageId,
                    insideExamineSettlesStatus: 1,
                    // remark: handleData ? handleData.approvalOptions : '',
                    remark: remark,
                }
                faileData = {
                    id: JSON.parse(query.dataContent).cycleManageId,
                    insideExamineSettlesStatus: 3,
                    // remark: handleData ? handleData.approvalOptions : '',
                    remark: remark,
                }
            } else if (this.dataType == 3) {
                successData = {
                    id: JSON.parse(query.dataContent).cycleManageId,
                    settleStatus: 4,
                    // remark: handleData ? handleData.approvalOptions : '',
                    remark: remark,
                }
                faileData = {
                    id: JSON.parse(query.dataContent).cycleManageId,
                    settleStatus: 3,
                    // remark: handleData ? handleData.approvalOptions : '',
                    remark: remark,
                }
            } else {
                successData = {
                    id: JSON.parse(query.dataContent).cycleManageId,
                    sureSelletesStatus: 1,
                }
                faileData = {
                    id: JSON.parse(query.dataContent).cycleManageId,
                    sureSelletesStatus: 3,
                }
            }
            const params = {
                process_success: {
                    url: this.dataType == 1 ? '/icps/system/sign/settlement/internalTotal/updaetSettleStatus' : this.dataType == 2 ? '/icps/system/sign/settlement/confirmTotal/updaetSettleStatus' : '/icps/system/sign/settlement/processTotal/updaetSettleStatus',
                    data: successData,
                    httpMethod: 'post',
                },
                process_failure: {
                    url: this.dataType == 1 ? '/icps/system/sign/settlement/internalTotal/updaetSettleStatus' : this.dataType == 2 ? '/icps/system/sign/settlement/confirmTotal/updaetSettleStatus' : '/icps/system/sign/settlement/processTotal/updaetSettleStatus',
                    data: faileData,
                    httpMethod: 'post',
                }
            }
            this.showSendVisible = false;
            this.$refs.flowcontent.handleToFlow(params);
        },
        /**
         * @Description: 
         * @Param: 1为保存，2为最后提交
         * @Author: wangwangwang
         * @param {*} type
         */
        handleFinish(type, processTaskId) {
            const { query } = this.$route;
            if (type == 1) {
                const updateMethods = this.dataType == 1 ? updaetInternalSettleStatus : this.dataType == 2 ? updaetConfirmSettleStatus : updateProcessSettleStatus
                let params = {}
                if (this.dataType == 1) {
                    params = {
                        id: JSON.parse(query.dataContent).cycleManageId,
                        insideExamineSettlesStatus: 2,
                    }
                } else if (this.dataType == 3) {
                    params = {
                        id: JSON.parse(query.dataContent).cycleManageId,
                        settleStatus: 2,
                    }
                } else {
                    params = {
                        id: JSON.parse(query.dataContent).cycleManageId,
                        sureSelletesStatus: 2,
                    }
                }
                updateMethods(params).then(() => {
                })
                const addExamineData = this.dataType == 1 ? addExamineDataInternal : this.dataType == 2 ? addExamineDataConfirm :
                    addExamineDataProcess
                let params2 = {
                    cycleManageId: JSON.parse(query.dataContent).cycleManageId,
                    cycleProcessManageId: JSON.parse(query.dataContent).cycleManageId,
                    processManagerId: this.processManagerId,
                    processVersionId: this.processVersionId,
                    processTaskId: processTaskId,
                }
                addExamineData(params2).then(() => {
                })

            }
        },
        handleSubmit(type) {
            const { query } = this.$route;
            if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 发起流程
                this.showSendVisible = true;
                return
            }
            this.billData.auditDataList = []
            console.log(this.billData)
            const data = {
                dataSource: 'sign_settlementTask',
                dataContent: JSON.stringify(this.billData), // 业务数据
            }
            this.$refs.flowcontent.saveFlows(type, data);
        },
        handleFlowChat() {
            this.$refs.flowcontent.showFlowNode()
        },
        handleCancel() {
            this.showSendVisible = false;
        },
        initFlowsData() {
            const { query } = this.$route;
            if (query.type * 1 !== 1) {
                this.title = query.taskName;
            }
            this.billCode = query.receiptNumber;
            this.billDate = query.createTime;
        },
        sendCode(code) {
            this.billCode = code;
        },
        sendProcessManagerId(processManagerId) {
            this.processManagerId = processManagerId;
        },
        sendProcessVersionId(processVersionId) {
            console.log(processVersionId)
            this.processVersionId = processVersionId;
            console.log("processVersionId-----------------------" + processVersionId)
        },
        getNodeList(list) {
            this.nodeList = list
        },
        exportSettle(isNode) {
           
            this.isNode = isNode
            //乙方公司
            this.exportForm['partyB'] = this.disClostDetail.collaborationUnitName
            //甲方公司
            this.exportForm['partyA'] = this.disClostDetail.roadworkType == 1 ? this.disClostDetail.constructionUnit : this.disClostDetail.constructionCompany
            if (isNode == 1) {
                const params = {
                    processManagerId: this.newBillData.totalList[0].processManagerId || this.processManagerId,
                    processTaskId: this.newBillData.totalList[0].processTaskId || this.processTaskId,
                    processVersionId: this.newBillData.totalList[0].processVersionId || this.processVersionId,
                }
                getNodeList(params).then(res => {
                    const newData = [];
                    const applyTypeList = ['-', '依次审批', '会签', '或签']
                    const flowsStatus = ['未审批', '待处理', '审批通过', '审批不通过', '发起人已撤销']
                    res.data.forEach((item, index) => {
                        let approvalOptions = ""
                        let handlerTime = ""
                        let approvalStatus = ""
                        let userName = item.instanceLogsList.map(sItem => sItem.userName)
                        if (item.nodeName == '抄送节点') {
                            approvalOptions = '-'
                            handlerTime = '-'
                            approvalStatus = userName ? '抄送' : '未抄送'
                        } else {
                            approvalOptions = item.instanceLogsList.map(sItem => sItem.approvalOptions)
                            handlerTime = item.instanceLogsList.map(sItem => sItem.handlerTime)
                            approvalStatus = index == 0 ? '-' : flowsStatus[item.approvalStatus]
                        }
                        const data = {
                            nodeName: item.nodeName,
                            userName: userName,
                            multiApprovalType: item.nodeName == '抄送节点' ? '-' : applyTypeList[item.multiApprovalType],
                            approvalOptions: approvalOptions,
                            handlerTime: handlerTime,
                            approvalStatus: approvalStatus,
                        }
                        newData.push(data);
                    });
                    const result = newData.reduce((acc, item) => {
                        acc.nodeName += (acc.nodeName ? '*' : '') + item.nodeName;
                        acc.userName += (acc.userName ? '*' : '') + item.userName;
                        acc.multiApprovalType += (acc.multiApprovalType ? '*' : '') + item.multiApprovalType;
                        acc.approvalOptions += (acc.approvalOptions ? '*' : '') + item.approvalOptions;
                        acc.handlerTime += (acc.handlerTime ? '*' : '') + item.handlerTime;
                        acc.approvalStatus += (acc.approvalStatus ? '*' : '') + item.approvalStatus;
                        return acc;
                    }, { nodeName: '', userName: '', multiApprovalType: '', approvalOptions: '', handlerTime: '', approvalStatus: '' });
                    console.log(result);
                    this.exportForm = { ...this.exportForm, ...result }
                    this.exportDig = true
                })
            } else {
                console.log(this.exportForm);
                this.exportDig = true
            }

        },
    },
    async created() {
        const { query } = this.$route;
        this.titlestatus = Number(query.type)
        this.billData = JSON.parse(query.dataContent)
        this.dataType = JSON.parse(query.dataContent).dataType
        if (query.processVersionId) {
            this.processVersionId = query.processVersionId
        }
        if (query.processManagerId) {
            this.processManagerId = query.processManagerId
        }
        if (query.processTaskId) {
            this.processTaskId = query.processTaskId
        }
        if (this.dataType == 1) {
            this.checkDetailType = 2
            this.changeEng('', false)
        } else if (this.dataType == 3) {
            this.checkDetailType = 4
            this.newBillData = JSON.parse(JSON.stringify(this.billData))
        } else {
            this.checkDetailType = 3
            this.changeEng('', false)
        }
        this.checkDetailRow = {
            id: this.billData.cycleManageId,
            engineeringName: this.billData.engineeringName,
            lastDueTime: this.billData.lastDueTime,
            currentDueTime: this.billData.currentDueTime,
        }
        this.exportForm = {
            cycleManageId: this.billData.cycleManageId,
            engineeringName: this.billData.engineeringName,
            lastDueTime: this.billData.lastDueTime,
            currentDueTime: this.billData.currentDueTime,
            dataType: this.checkDetailType,
        }
        //主工程
        this.cycleId = this.billData.cycleManageId
        if (this.dataType == 1) {
            let res = await queryChildEngCycles({ id: this.billData.cycleManageId })
            if (res.code == 1001) {
                this.bindEngList = res.data
            }
        }
        if (this.dataType == 2) {
            let res = await queryRelevanceCycles({ id: this.billData.cycleManageId })
            if (res.code == 1001) {
                this.bindEngList = res.data
                this.bindEngList.forEach(item => {
                    item['childCycleId'] = item.id
                });
            }
        }
        let disClostRes = await getDisClostDetail({ id: this.billData.engineeringId })
        if (disClostRes.code == 1001) {
            this.disClostDetail = disClostRes.data
            console.log(this.disClostDetail)
        }
        this.additional = this.billData.additional
        if (this.billData.files) {
            this.files = JSON.parse(this.billData.files)
        }
        getStationByCompanyId({ engineeringId: this.billData.engineeringId }).then(res => {
            if (res.code == 1001) {
                this.stationIdlist = res.data
            }
        })
        // this.additional = this.additional.map(item => [item])
    },
    watch: {
        // 四川华西集采电子商务有限公司
        disClostDetail(newVal) {
            if (newVal && Object.keys(newVal).length > 0) {
                console.log(newVal.roadworkType)
                
                if (newVal.roadworkType == 1 ? newVal.constructionUnit == '四川华西集采电子商务有限公司' || newVal.constructionUnit == '四川华西数产科技集团有限公司' : newVal.constructionCompany == '四川华西集采电子商务有限公司' || newVal.constructionCompany == '四川华西数产科技集团有限公司') {
                    this.title = '(集采)' + this.title
                }
            }
        }
    },
    mounted() {
        const { query } = this.$route;

        // this.additional = ['细石', '测试']
        if (query.type * 1 === 1) { // 发起流程
            this.$refs.flowcontent.initBaseData(this.dataType == 3 ? 'sign_settlementTask_process' : 'sign_settlementTask_Company');
            this.billDate = new Date().Format('yyyy-MM-dd hh:mm:ss');
            this.applyPerson = getUserInfo().userRealName;
            this.title = this.dataType == 1 ? ('内审结算任务审批-' +this.billData.engineeringName ) : this.dataType == 2 ? ('返回结算任务审批-'+this.billData.engineeringName ) : ('过程核定量结算任务审批-'+this.billData.engineeringName )
            return
        }
        this.initFlowsData()
        this.applyPerson = query.createUserName;
        this.taskStatus = query.taskStatus;
        if (query.isReadOnly * 1 === 1) {
            this.readOnly = true;
        }
        this.userInfo = getUserInfo()
    }
}
</script>
<style lang="scss" scoped>
.bill_top {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    line-height: 40px;

    .text {
        font-weight: 600;
        color: #000;
    }
}

.bill_title {
    font-size: 18px;
    font-weight: 600;
    padding: 15px 0;
}

.bill_title1 {
    font-size: 18px;
    font-weight: 600;
    padding: 20px 0;
}

.bill_subtitle {
    padding: 20px 0;

    >span {
        padding-right: 20px;
    }

    .text {
        color: #000;
    }
}

.combined {
    border: 1px solid #ebeef5;
    text-align: center;
    line-height: 40px;
}

.flows-details {
    margin-top: 20px;
}

.info {
    padding: 0 20px;
    background: #fff;

    .info-top {
        font-size: $font_size;
        color: #000000;
        @include discen_al;
        justify-content: space-between;
        height: 50px;
        border-bottom: 1px #e1e5ed solid;

        .left {
            @include discen_al;
        }

        .text {
            margin-left: 60px;
        }
    }
}

.nav_title {
    @include discen_al;
    align-items: flex-end;

    >div {
        width: 4px;
        height: 24px;
        background: $bg_color;
        margin-right: 10px;
    }

    i {
        margin-left: 5px;
    }

    color: $bg_color;
    font-size: 20px;
    font-weight: bold;
}

.dialoginfo {
    padding: 0;
}

.active {
    border-top: 1px #e1e5ed solid;
    border-right: 1px #e1e5ed solid;
    border-left: 1px #e1e5ed solid;
    background: #fff;
}

.dialoginfo-info {
    border-right: 1px #e1e5ed solid;
    border-left: 1px #e1e5ed solid;
    border-bottom: 1px #e1e5ed solid;
}

/*弹窗*/
.dialoginfo-title {
    >div {
        cursor: pointer;
    }

    height: 48px;
    display: flex;
    background: linear-gradient(180deg,
        rgba(250, 252, 255, 1) 0%,
        rgba(245, 247, 250, 1) 100%);

    .none {
        font-weight: bold;
        height: 48px;
        @include discen;
        width: calc(calc(100% - 1px) / 2);
        border-bottom: 1px solid #e1e5ed;

        >div {
            line-height: 48px;
            border-bottom: 1px rgba(0, 0, 0, 0) solid;
        }
    }

    .center {
        width: 1px;
        height: 48px;
        background: #e1e5ed;
    }

    .active {
        font-weight: bold;
        height: 48px;
        @include discen;
        width: calc(calc(100% - 1px) / 2);
        border-bottom: 1px solid rgba(0, 0, 0, 0);

        >div {
            color: $bg_color;
            line-height: 48px;
            border-bottom: 1px $bg_color solid;
        }
    }
}

.dialoginfo-info {
    padding: 10px 20px;
    overflow: auto;
    height: calc(85vh - 282px);

    .el-select,
    .el-input,
    .el-date-picker {
        width: 100%;
    }
}

.form-title {
    font-size: 18px;
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
}

.el-link {
    color: $bg_color;
}

.el-link:hover {
    color: $bg_color;
    opacity: 0.7;
}
</style>